import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

import { useCart } from '@/entities/cart'

import { sendYandexMetricaEvent } from '@/shared/integrations/yandex-metric/utils/send-metric-event'
import { Button, ButtonProps, Flex, Text } from '@/shared/ui'

import { OrderInfo } from '../order-info/order-info'

import styles from './basket-summary.module.scss'

export const CHECKOUT_BUTTON_ID = 'cart-checkout-button'

export const BasketInfoOrderButton = (props: ButtonProps): JSX.Element => {
	const pathname = usePathname()
	const searchParams = useSearchParams()

	const [isLoading, setIsLoading] = useState<boolean>(false)
	const { isLoading: isDataLoading } = useCart()

	const onClick = () => {
		sendYandexMetricaEvent('click-oformit-zakaz')
		setIsLoading(true)
	}

	useEffect(() => {
		setIsLoading(false)
	}, [pathname])

	return (
		<Link prefetch={false} href={{ pathname: `/order`, query: searchParams.get('query') }}>
			{/* @next-codemod-error This Link previously used the now removed `legacyBehavior` prop, and has a child that might not be an anchor. The codemod bailed out of lifting the child props to the Link. Check that the child component does not render an anchor, and potentially move the props manually to Link. */}
			<Button
				className={styles.orderButton}
				isLoading={isLoading || isDataLoading}
				disabled={isLoading || isDataLoading}
				onClick={onClick}
				title="Перейти к оформлению заказа"
				{...props}>
				Оформить заказ
			</Button>
		</Link>
	)
}

/**
 * Block with order price info
 */
export const BasketSummary = (): JSX.Element => {
	const { basePrice, price, cartCount, serviceCount = 0, discountList } = useCart()
	const saleValue = basePrice - price

	return (
		<section className={styles.basketSummary}>
			<Flex column rowGap={14}>
				<Text className={styles.title}>В корзине:</Text>

				{/* Total price, sale and bonus */}
				<OrderInfo
					productCount={cartCount - serviceCount}
					servicesCount={serviceCount}
					totalSum={price}
					tradeInSum={0}
					promoCodeSum={0}
					sale={saleValue < 0 ? 0 : saleValue}
					bonusPay={0}
					basePrice={basePrice}
					discountList={discountList}
					isOrder
				/>

				{/* Panel with pay buttons */}
				<div id={CHECKOUT_BUTTON_ID}>
					<BasketInfoOrderButton />
				</div>
				<div className={styles.tooltipText}>Управлять промокодами вы сможете при оформлении заказа</div>
			</Flex>
		</section>
	)
}
